import {
  listGroupSets,
  listGroupSetsResolved,
  listGroupSetsRejected,
} from '@Actions/groupSets.actions';

import { put, takeLatest, retry } from '@redux-saga/core/effects';
import { error } from '@innovyze/stylovyze';
import { AxiosResponse } from 'axios';
import { getGroupSets } from '@Services/groupSets.services';

import { GroupSetsResponse, ApiError } from '@Types';

function* listGroupSetsSaga() {
  try {
    const payload: AxiosResponse<GroupSetsResponse> = yield retry(
      5,
      15000,
      getGroupSets
    );
    yield put(listGroupSetsResolved(payload.data.data));
  } catch (e) {
    console.error('Error retrieving group sets:', e);
    const apiError = e as ApiError;
    const { response } = apiError;
    yield put(
      listGroupSetsRejected({
        code: response?.status ?? -1,
        text: response?.statusText ?? 'Failed to fetch group sets',
      })
    );
    yield put(error('Unable to load group sets'));
  }
}

function* watchListGroupSetsSaga() {
  yield takeLatest(listGroupSets, listGroupSetsSaga);
}

export default [watchListGroupSetsSaga];
